import React from 'react';

export default function SpaceDivider() {
  return (
    <div className='space__divider'></div>
  )
}
